export default {
  data() {
    return {}
  },
  methods: {
    getNormalizedText(txt) {
      return txt
        .trim()
        .toLowerCase()
        .replaceAll(new RegExp(/&/g), 'and')
        .replaceAll(new RegExp(/ö/g), 'oe')
        .replaceAll(new RegExp(/ä/g), 'ae')
        .replaceAll(new RegExp(/ü/g), 'ue')
        .replaceAll(new RegExp(/&/g), 'and')
        .replaceAll(new RegExp(/\s/gi), '-')
        .match(new RegExp(/[a-z0-9-\s]+/gi))
        .join('')
        .replaceAll('--', '-')
    }
  }
}
